import { render, staticRenderFns } from "./RelationshipGraph.vue?vue&type=template&id=6d328480&scoped=true"
import script from "./RelationshipGraph.vue?vue&type=script&lang=js"
export * from "./RelationshipGraph.vue?vue&type=script&lang=js"
import style0 from "./RelationshipGraph.vue?vue&type=style&index=0&id=6d328480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d328480",
  null
  
)

export default component.exports